import { Component,OnInit } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from '.../../environments/environment'; 
import { AuthService } from '../../../_services/index'; 
import { LoaderService } from 'app/_services/loader.service'; 
import Swal from 'sweetalert2' 
import * as _moment from 'moment';  
import * as _rollupMoment from 'moment'; 
import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver'; 

declare var $: any;
@Component({
  selector: 'TSMaster',
  templateUrl: './tsMaster.component.html', 
})
export class TsMasterComponent implements OnInit{  
  employeeData:any;
  prjId:any;
  userId:any;
  showLoader:boolean  
  tsMappingList:any;
  TSAssignList:any;
  tsEntityModal:any;
  entityList:any;
  entityTypeModel:any; 
  currentEntityId:any;   
  assignStatus:any;
  TSUnAssignList:any;
  currentTsId:any;
  unAssignLength:any;
  assignLength:any; 
  changeStatusId:any;
  titleMsg:any; 
  currentTsNo:any;
  search:any;
  tsRequired=false;
  tsMasterSearch:any;
  tsSearch:any; 
  selectedRow:number;
    constructor(private http : HttpClient,private auth:AuthService,private loaderService: LoaderService){
    this.loaderService.status.subscribe((val: boolean) =>{
      this.showLoader = val;
    }); 
  }   
  
    /*
    * Get TS List
    */
    getTsList() { 
        this.loaderService.display(true);  
        this.http.get(environment.apiUrl+'maintenance/getTsList?prjId='+this.prjId).subscribe((data)=>{ 
        this.tsMappingList=data
         if(this.tsMappingList.length==0){
          this.tsRequired=true;
         }else{
          this.tsRequired=false;
         }
        this.loaderService.display(false); 
      }); 
    }

    /*
    * TS mapping Modal popup Windows Open
    */  
    tsMapping(data){
        this.loaderService.display(true); 
        console.log("View Data",data)
        this.currentTsNo=data.TSNO
        this.currentTsId=data.ID 
        $('#tsViewModal').modal('show') 
        this.getAssignTSList(this.currentTsId)
        this.loaderService.display(false); 
    }
    
   

   /*
    * get ALL LOCATION BY TS ID
    */
   getAssignTSList(tsId){ 
    this.http.get(environment.apiUrl + 'maintenance/getassignTSList?prjId='+this.prjId+'&tsId='+tsId).subscribe(data =>{ 
    this.TSAssignList=data  
    this.assignLength=this.TSAssignList.length
    });
   } 



    /*
    * Select The Assign/Unassign ddl list
    */
   setStatus(data){ 
    if(data.ActiveStatus=="Unassigned"){
      this.assignStatus="Assign"
    }else{
      this.assignStatus="Unassigned"
    }
  }


    /*
    * Assign/Unassign TS status
    */
  setAssignStatus(data){  
    if(data.ActiveStatus=="Unassigned"){
      this.changeStatusId=1
      this.titleMsg="Are you sure to Assign this TS for This Location ?" 
    }else{
      this.changeStatusId=0
      this.titleMsg="Are you sure to Unassign this TS from This Location ?" 
    }
    var assignData={    
      "TSID": this.currentTsId,
      "ENTITYID":data.ENTITYID,
      "ISACTIVE":this.changeStatusId,
      "userId":this.userId  
    } 
    Swal({
      title: this.titleMsg, 
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Convert it!'
    }).then((result) => {
      if (result.value) { 
        this.http.post(environment.apiUrl + "maintenance/tsAssignment", assignData).subscribe(data =>{ 
            var response = data  
            var resCode = response[0].RESPONSECODE            
            var respMsg=response[1].RESPONSEMESSAGE
            console.log("data",respMsg) 
            if (resCode == "200") { 
                this.getAssignTSList(this.currentTsId); 
                this.getTsList();
              Swal( 
                 respMsg,
                'success'
                ) 
                } else 
                { 
                Swal(
                respMsg,
                'error'
                ) 
            }
          });
      }
    })   
  }


    /*
    * DownLoad Excel file
    */
  downloadExcel(tsMappingList){
    const ws_name = 'TsAssignmentReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(tsMappingList);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'TsAssignmentReport.xlsx');
  }
  s2ab(s) 
    {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
      };
      return buf;
    }


    // selectRowIndex(index,data){
    //   this.selectedRow=index;
    // }

  
  

  ngOnInit(): void{    
    this.prjId=this.auth.getAuthentication().projectId 
    this.userId=this.auth.getAuthentication().id 
    this.getTsList();  
   } 
}



// WEBPACK FOOTER //
// ./src/app/maintenance/TS/tsMaster/tsMaster.component.ts